"use client";

import { useDispatch, useSelector } from "react-redux";
import { RootState } from "@/src/store/store";
import { closeModal } from "@/src/store/slices/allModalSlice";
import { useDeleteUserAddressMutation } from "@/src/store/rtkQueries/userPostAPI";
import { Button } from "@heroui/react";
import Loader from "@/src/ui/Loader";
import { TrashIconSVG } from "@/src/ui/AllSVG";
import { toast } from "@/src/lib/toast";

export default function DeleteAddressModal() {
    const dispatch = useDispatch();
    const { data } = useSelector((state: RootState) => state.allCommonModal);
    const [deleteUserAddress, { isLoading }] = useDeleteUserAddressMutation();

    const addressId = data?.addressId as string | undefined;
    const displayName = (data?.displayName as string | undefined) ?? "this address";

    const handleDelete = async () => {
        if (!addressId) return;
        try {
            const response = await deleteUserAddress(addressId).unwrap();
            if (response.http_status_code === 200 || response.http_status_code === 201) {
                toast.success(response.message || "Address removed");
                dispatch(closeModal());
            }
        } catch (error) {
            console.error(error);
        }
    };

    return (
        <div className="flex flex-col items-center gap-6 py-2 text-center">
            {isLoading && <Loader />}

            <div className="flex items-center justify-center w-14 h-14 rounded-full bg-red-50">
                <TrashIconSVG />
            </div>

            <div className="space-y-1.5">
                <h3 className="text-base font-semibold">Delete address</h3>
                <p className="text-sm text-body-color/60 max-w-xs">
                Are you sure you want to delete this address? This cannot be undone.
                </p>
            </div>

            <div className="flex gap-3 w-full">
                <Button
                    onPress={() => dispatch(closeModal())}
                    isDisabled={isLoading}
                    className="flex-1 border border-muted-color bg-transparent text-body-color text-sm font-medium rounded-full py-2.5"
                >
                    Cancel
                </Button>
                <Button
                    onPress={handleDelete}
                    isDisabled={isLoading || !addressId}
                    className="flex-1 bg-red-500 text-white text-sm font-medium rounded-full py-2.5"
                >
                    Delete
                </Button>
            </div>
        </div>
    );
}
